import { createApiCall } from 'lib/base';

const FETCH_NHSV_SMS_OTP = 'FETCH_NHSV_SMS_OTP';

const getOtp = createApiCall(FETCH_NHSV_SMS_OTP, ({ id }: { id: string }) => ({
  endpoint: `/api/admin/bank-accounts/${id}/nhsv/get-otp`,
  method: 'POST',
}));

export default getOtp;
